export default __webpack_public_path__ + "static/media/Stadium.e496b778.png";